import React from 'react';
import styles from './not-found.module.css';

export function NotFound() {
  return (
    <main className={styles.main}>
      <h1 className={styles.notFound}>PAGE NOT FOUND!</h1>
    </main>
  );
}
